import {createSvgIcon} from '@yandex-delivery/blocks/icons/utils'

export default createSvgIcon(
  <path d="M14 2.00037H6C4.9 2.00037 4 2.90037 4 4.00037V20.0004C4 21.1004 4.89 22.0004 5.99 22.0004H18C19.1 22.0004 20 21.1004 20 20.0004V8.00037L14 2.00037ZM18 20.0004H6V4.00037H13V9.00037H18V20.0004Z" />,
  'DraftIcon',
)
